import React from "react";

const Footer = () => (
  <footer className="sticky-footer bg-white">
    <div className="container my-auto">
      <div className="copyright text-center my-auto">
        <span>Direitos reservados &copy; SEFAZ-RN</span>
      </div>
    </div>
  </footer>
);

export default Footer;
